import { render } from "./WheelEventCapturer.vue?vue&type=template&id=53a4a046"
import script from "./WheelEventCapturer.vue?vue&type=script&lang=js"
export * from "./WheelEventCapturer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__